export const UserAccess = ()=>(
    { Name: 'custom:Access', Value: JSON.stringify(
        {
            ops:  false,
            ops_individual:  false,
            ops_semelhanca:  false,
            ops_geracao:  true,
            ops_geracao_ia:  false,
            ops_historico:  true,
            ops_integracoes:  false,
            ops_tech:  false,
            ops_gpt:  false,
            ops_enriquecimento: false,
    
            aiv:  false,
            aiv_configuracao:  false,
            aiv_tarefa:  false,
            aiv_analytics:  false,
    
            analytics:  false,
            analytics_venda:  false,
            analytics_icpmap:  false,
            analytics_funnelmap:  false,

            sales_ai:  false,
    
            administrativo:  false
            }
          )}
)

export const UserAccessAuth = ()=>(
    JSON.stringify(
        {
            ops:  false,
            ops_individual:  false,
            ops_semelhanca:  false,
            ops_geracao:  true,
            ops_geracao_ia:  false,
            ops_historico:  true,
            ops_integracoes:  false,
            ops_tech:  false,
            ops_gpt:  false,
            ops_enriquecimento: false,
        
            aiv:  false,
            aiv_configuracao:  false,
            aiv_tarefa:  false,
            aiv_analytics:  false,
        
            analytics:  false,
            analytics_venda:  false,
            analytics_icpmap:  false,
            analytics_funnelmap:  false,

            sales_ai:  false,
        
            administrativo:  false
        }
    )
    
)